import { FilterGroup } from "src/app/modules/core/store/models";

export interface RuleConfiguration
{
  filterGroup?: FilterGroup;
}

export interface DateRuleConfiguration extends RuleConfiguration
{
  sourceType: DateRuleSourceType;
  offsetType: DateRuleOffsetType;
  dateOffset: number;
  specificDate?: string;
  fieldName?: string;
}

export enum DateRuleOffsetType
{
  None = 0,
  Hours = 1,
  Days = 2,
  Weeks = 3,
  Months = 4,
  Years = 5,
  Minutes = 6
}

export enum DateRuleOffsetDir {
  None = 0,
  after = 1,
  before = 2,
}

export enum DateRuleSourceType
{
  None = 0,
  StepStart = 1,
  DocumentField = 2
}
